/* eslint-disable import/named */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import { StylesProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment'; 
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux';
import { AuthorizationHandler, PopupManager } from './providers';
import { azureLoginPage } from './utils/utils';

const MainApp = () => {
  let code =''
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    code = urlParams.get("code");
    const isLoggedIn = sessionStorage.getItem("isAuthenticated") === "true";
    if (!code && !isLoggedIn) {
      azureLoginPage();
    } 
  }, []);

  return (
    <React.StrictMode>
      <StylesProvider injectFirst>
        <Provider store={store}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <PopupManager>
              <AuthorizationHandler>
                <Router>
                  <App />
                </Router>
              </AuthorizationHandler>             
            </PopupManager>
          </MuiPickersUtilsProvider>
        </Provider>
      </StylesProvider>
    </React.StrictMode>
  );
};

ReactDOM.render(
  <MainApp />,
  document.getElementById('root')
);

reportWebVitals();
